import { ResponseJSON, uploadArquivo } from 'api';
import { PartialUpdateUserData } from 'api/user/api.types';
import { parseDate, verificarDatas, validarData, MENSAGENS } from 'utils/uteis';

export const getNameByUuidCreate = (
  uuid: string,
  list: { data: { uuid: string; name: string }[] },
) => {
  const item = list.data.find((entry) => entry.uuid === uuid);
  return item ? item.name : 'N/A';
};

export const getTipoRepresentanteCreate = (permissaoParm?: string): boolean => {
  return (
    permissaoParm?.trim().toUpperCase() === 'REPRESENTANTE LEGAL MUNICIPAL' ||
    false
  );
};

export const tratarPermissoesUsuarioCreate = (
  permissoes: { data: { name: string; uuid?: string }[] },
  perfilID: any,
  profilesDropdownParm: { data: { uuid: string; name: string }[] } | undefined,
) => {
  const permissoesAjustadas: any = permissoes;
  const PerfilNome = profilesDropdownParm?.data
    ?.find((item) => item.uuid === perfilID)
    ?.name?.toUpperCase();

  if (PerfilNome && permissoes?.data?.length > 0) {
    if (PerfilNome.indexOf('MUNICIPAL') > -1 || PerfilNome.indexOf('MUNICIPIO') > -1) {
      permissoesAjustadas.data = permissoes.data.filter((item: { name: string }) => {
        return item.name.toUpperCase().indexOf('ESTADUAL') === -1;
      });
    } else {
      if (PerfilNome.indexOf('ESTADUAL') > -1 || PerfilNome.indexOf('ESTADO') > -1) {
        permissoesAjustadas.data = permissoes.data.filter((item: { name: string }) => {
          return item.name.toUpperCase().indexOf('MUNICIPAL') === -1;
        });
      }
    }
  }

  return permissoesAjustadas;
};

export const construirUserDataCreatePure = (
  values: any,
  arquivoUuid: any,
  options?: {
    primeiroAcessoInstituicao?: any;
    PRIMEIRO_ACESSO?: boolean;
    dataVigenciaIndeterminada?: boolean;
    dataVigenciaInicial?: string;
    dataVigenciaFinal?: string;
  },
) => {
  const {
    primeiroAcessoInstituicao,
    PRIMEIRO_ACESSO = false,
    dataVigenciaIndeterminada = false,
    dataVigenciaInicial = '',
    dataVigenciaFinal = '',
  } = options || {};

  let userData: any = {
    name: values.personalData.name,
    identification: values.personalData.cpf,
    email: values.personalData.email,
    contactList: [
      {
        type: 'CELULAR',
        value: '+55' + values.personalData.phone.replace(/\D/g, ''),
      },
    ],
    position: values.personalData.position,
    groupUuid: values.loginData.group,
    profileUuid: values.loginData.profile,
    permissionUuid: values.loginData.permission,
    representativeFileUuid: arquivoUuid?.uuid,
    isRegisterActive: values.registrationData.activeRegistration,
    isRegisterBlocked: values.registrationData.blockRegistration,
    hasAcceptedConfidentialityTerm: false,
    hasAcceptedTermOfUse: false,
    address: {
      municipality: values.personalData.municipalities,
    },
    institutionUuid: null,
    dadosVigencia: null,
  };

  if (getTipoRepresentanteCreate()) {
    userData.dadosVigencia = {
      vigenciaIndeterminada: dataVigenciaIndeterminada,
      dataInicial: dataVigenciaInicial ? parseDate(dataVigenciaInicial) : null,
      dataFinal: dataVigenciaFinal ? parseDate(dataVigenciaFinal) : null,
      isActive: true,
      representativeFileUuid: arquivoUuid?.uuid,
    };
  }

  if (PRIMEIRO_ACESSO) {
    userData = {
      ...userData,
      isRegisterActive: false,
      isRegisterBlocked: false,
      hasAcceptedTermOfUse: true,
      hasAcceptedConfidentialityTerm: true,
      institutionUuid: primeiroAcessoInstituicao?.uuid,
    };
  }

  return userData;
};

export const validarDadosCreatePure = (params?: {
  isRepresentante?: boolean;
  dataVigenciaInicial?: string;
  dataVigenciaFinal?: string;
  dataVigenciaIndeterminada?: boolean;
  userFormAction?: string;
  arquivoAnexo?: { nomeArquivoOriginal?: string; nomeArquivo?: string } | null;
}) => {
  const {
    isRepresentante = false,
    dataVigenciaInicial = '',
    dataVigenciaFinal = '',
    dataVigenciaIndeterminada = false,
    userFormAction,
    arquivoAnexo,
  } = params || {};

  if (isRepresentante) {
    if (!dataVigenciaInicial || dataVigenciaInicial.trim() == '') {
      alert(`Data de Inicio ${MENSAGENS.PREENCHIMENTO_OBRIGATORIO}`);
      return false;
    }

    if (!validarData(dataVigenciaInicial)) {
      alert(`Data de Início ${MENSAGENS.PREENCHIMENTO_INVALIDO}`);
      return false;
    }

    if (!dataVigenciaIndeterminada) {
      if (!dataVigenciaFinal || dataVigenciaFinal.trim() == '') {
        alert(`Data Fim ${MENSAGENS.PREENCHIMENTO_OBRIGATORIO}`);
        return false;
      }

      if (!validarData(dataVigenciaFinal)) {
        alert(`Data Fim ${MENSAGENS.PREENCHIMENTO_INVALIDO}`);
        return false;
      }

      if (!verificarDatas(dataVigenciaInicial, dataVigenciaFinal)) {
        alert(
          'A Data Final de Vigência deve ser posterior a Data Inicial. Verifique e selecione uma Data válida para continuar',
        );
        return false;
      }
    }

    if (
      userFormAction === 'CADASTRAR' &&
      !(arquivoAnexo && (arquivoAnexo.nomeArquivoOriginal?.length ?? 0) > 0)
    ) {
      alert('Para Representante Municipal o Arquivo Anexo é obrigatório');
      return false;
    }
  }

  return true;
};

export const processarArquivoCreateHelper = async (arquivoAnexo: any) => {
  if (!arquivoAnexo) return null;
  const Resp: any = await uploadArquivo({
    ...arquivoAnexo,
    type: 'COMPROVANTE DE REPRESENTANTE LEGAL MUNICIPAL',
  });

  if (Resp.Status === 'OK') {
    return Resp.dados as ResponseJSON;
  } else {
    alert(Resp.Mensagem);
    return null;
  }
};

export const gerarDadosAtualizadosCreatePure = (values: any, options?: {
  userDetails?: any;
  getTipoRepresentante?: () => boolean;
  dataVigenciaIndeterminada?: boolean;
  dataVigenciaInicial?: string;
  dataVigenciaFinal?: string;
}) => {
  const { userDetails, getTipoRepresentante, dataVigenciaIndeterminada, dataVigenciaInicial, dataVigenciaFinal } = options || {};

  const hasChanged = (original: any, updated: any) => {
    return JSON.stringify(original) !== JSON.stringify(updated);
  };

  const updatedData: Partial<PartialUpdateUserData> = {};

  if (getTipoRepresentante && getTipoRepresentante()) {
    updatedData.dadosVigencia = {
      vigenciaIndeterminada: !!dataVigenciaIndeterminada,
      dataInicial: dataVigenciaInicial ? parseDate(dataVigenciaInicial) : null,
      dataFinal: dataVigenciaFinal ? parseDate(dataVigenciaFinal) : null,
      isActive: true,
    } as any;
  }

  if (hasChanged(userDetails?.personalData?.email, values.personalData.email)) {
    updatedData.email = values.personalData.email;
  }

  if (hasChanged(userDetails?.personalData?.phone, values.personalData.phone)) {
    updatedData.contactList = [
      {
        uuid: userDetails?.personalData?.uuidPhone,
        type: 'CELULAR',
        value: values.personalData.phone,
      },
    ];
  }

  if (hasChanged(userDetails?.personalData?.position, values.personalData.position)) {
    updatedData.position = values.personalData.position;
  }

  if (hasChanged(userDetails?.loginData?.profileUuid, values.loginData.profile)) {
    updatedData.profileUuid = values.loginData.profile;
  }

  if (hasChanged(userDetails?.loginData?.groupUuid, values.loginData.group)) {
    updatedData.groupUuid = values.loginData.group;
  }

  if (hasChanged(userDetails?.loginData?.permissionUuid, values.loginData.permission)) {
    updatedData.permissionUuid = values.loginData.permission;
  }

  if (hasChanged(userDetails?.loginData?.password, values.loginData.password)) {
    updatedData.password = values.loginData.password;
  }

  updatedData.isRegisterActive = values.registrationData.activeRegistration;
  updatedData.isRegisterBlocked = values.registrationData.blockRegistration;
  updatedData.representativeFileUuid = values.anexo.uuid;

  return updatedData;
};

export const verificarAlteracaoDeVigenciaPure = (params?: {
  userDetails?: any;
  user?: any;
  getTipoRepresentante?: () => boolean;
  dataVigenciaIndeterminada?: boolean;
  dataVigenciaInicial?: string;
  dataVigenciaFinal?: string;
}) => {
  const { userDetails, user, getTipoRepresentante, dataVigenciaIndeterminada, dataVigenciaInicial, dataVigenciaFinal } = params || {};

  if (
    userDetails?.personalData?.uuid === user?.uuid &&
    getTipoRepresentante && getTipoRepresentante()
  ) {
    return (
      (!userDetails?.dadosVigencia?.dataInicial && dataVigenciaInicial) ||
      (!userDetails?.dadosVigencia?.dataFinal && dataVigenciaFinal) ||
      JSON.stringify(userDetails?.dadosVigencia?.vigenciaIndeterminada) !== JSON.stringify(dataVigenciaIndeterminada) ||
      JSON.stringify(userDetails?.dadosVigencia?.dataInicial) !== JSON.stringify(dataVigenciaInicial) ||
      JSON.stringify(userDetails?.dadosVigencia?.dataFinal) !== JSON.stringify(dataVigenciaFinal)
    );
  }

  return false;
};

export default {};
